import styled from 'styled-components';

import { Box } from '../../../../common/ui/Box';
import { theme } from '../../../../common/ui/theme';

interface CategoryProps {
    isCheapest: boolean;
}

export const Category = styled(Box)<CategoryProps>`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    padding: ${theme.space[12]};
    position: relative;

    background: ${(props) =>
        props.isCheapest
            ? 'linear-gradient(212.33deg, rgba(0, 204, 105, 0.2) 0%, rgba(255, 255, 255, 0) 40%)'
            : 'linear-gradient(0deg, rgba(1, 1, 1, 0))'};
`;
